import React, { Component } from 'react';
import { HashRouter, Route, Link, Switch } from 'react-router-dom';
import './App.css';
import Home from './modules/Home';
import Login from './modules/Login';
import Amplify, { Auth, Hub } from 'aws-amplify';
import { Greetings } from 'aws-amplify-react';
import aws_secrets from './aws-secrets';

Amplify.configure(aws_secrets);

class App extends Component {
  constructor(props) {
    super(props);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.state = {
      authState: null,
      authData: null
    };
    Hub.listen('auth', this, 'AuthListener');
  }

  getCurrentAuthData() {
    var authData = {};
    Auth.currentAuthenticatedUser().then(data => {
      authData.username = data.username;
    });
    Auth.currentSession().then(data => {
      authData.email = data.idToken.payload.email;
      authData.idToken = data.idToken.jwtToken;
      authData.refreshToken = data.refreshToken.token;
      authData.accessToken = data.accessToken.jwtToken;
    });
    Auth.currentUserInfo().then(data => {
      authData.id = data.id;
    });
    console.log(JSON.stringify(authData));
    return authData;
  }

  handleStateChange(authState, authData) {
    authData = this.getCurrentAuthData();
    this.setState({
      authState,
      authData
    });
  }

  onHubCapsule(capsule) {
    const { channel, payload } = capsule;
    if (channel === 'auth') {
      this.onAuthEvent(payload);
    }
  }

  onAuthEvent(payload) {
    const { event, data } = payload;
    console.log('onAuthEvent:', event);
    switch (event) {
      case 'signIn':
        // this.handleStateChange(this.getCurrentAuthData());
        break;
      case 'signOut':
        // this.handleStateChange({authData: null});
        break;
      default:
        break;
    }
  }

  componentDidMount() {
    console.log('componentDidMount')
    // this.handleStateChange(this.state.authState, this.getCurrentAuthData());
  }

  render() {
    return (
      <HashRouter>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <div className="nav">
                <ul>
                  <li className="active">
                    <Link to="/">*Home*</Link>
                  </li>
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                  <li>
                    <Greetings onStateChange={this.handleStateChange} />
                  </li>
                </ul>
              </div>
            </Route>
            <Route exact path="/login">
              <div className="nav">
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li className="active">
                    <Link to="/login">*Login*</Link>
                  </li>
                </ul>
              </div>
            </Route>
          </Switch>
          <Switch>
            <Route exact path="/" name="home" render={(props) => (
              <Home {...props}
                authState={this.state.authState}
                authData={this.state.authData}
              />
            )}/>
            <Route exact path="/login" name="login" component={Login} />
          </Switch>
        </div>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js